import { theme } from '@ublend-npm/aulaui-next';

export default {
  container: {
    width: 'calc(100% - 40px)',
    height: 40,
    position: 'fixed',
    top: 0,
    left: 0,
    padding: 20,
    backgroundColor: theme.color.white,
    boxShadow: '0 0 8px 0 rgba(0, 0, 0, 0.4)',
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'space-between',
  },
  link: {
    textDecoration: 'none',
    fontSize: 14,
    color: theme.color.grayDark,
    marginLeft: 14,
  },
  backButton: {
    position: 'absolute',
    top: 20,
    left: 'calc(50% - 40px)',
    height: 40,
    width: 80,
    backgroundColor: theme.color.grayLight,
    borderRadius: 3,
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    color: theme.color.green0,
    cursor: 'pointer',
    fontSize: 13,
    ':hover': {
      transition: 'all linear 0.2s',
      backgroundColor: theme.color.grey3,
    },
  },
};
